export default __webpack_public_path__ + "static/media/Shiv of the Triumphant.d6f6f17c.jpg";